import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container frame" }

import { useRoute, useRouter } from "vue-router";
import { computed, ref, onMounted, Ref, reactive, onUnmounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const mytext = ref<string>("");

onMounted(async () => {
  let hash = route.hash;

  try {
    if (hash.startsWith("#")) {
      const parts = hash.split("/");
      if (parts.length > 2) {
        if (parts[1] === "optin") {
          router.replace({ name: "Optin", params: { id: parts[2] } });
          //mytext.value = "about to redirect to optin page with token " + parts[2];
        }
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(mytext.value), 1)
  ]))
}
}

})